export default __webpack_public_path__ + "static/media/SEN-TEM-PROBE.836ced74.png";